var map = {
	"./Badges.abi.js": 264,
	"./BuffiDai.abi.js": 265,
	"./Burner.abi.js": 266,
	"./BurnerVendor.abi.js": 267,
	"./DenDai.abi.js": 268,
	"./ENS.abi.js": 183,
	"./ENSResolver.abi.js": 184,
	"./ERC20Vendable.abi.js": 269,
	"./Emitter.abi.js": 185,
	"./Exchange.abi.js": 182,
	"./Links.abi.js": 270,
	"./StableCoin.abi.js": 186,
	"./VendingMachine.abi.js": 271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;